import { render, staticRenderFns } from "./OrganismPartner.vue?vue&type=template&id=5b339038&scoped=true&"
import script from "./OrganismPartner.vue?vue&type=script&lang=js&"
export * from "./OrganismPartner.vue?vue&type=script&lang=js&"
import style0 from "./OrganismPartner.vue?vue&type=style&index=0&id=5b339038&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b339038",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsPortfolioAtomPartner: require('/app/components/atoms/portfolio/AtomPartner.vue').default,MoleculesPortfolioMoleculePartner: require('/app/components/molecules/portfolio/MoleculePartner.vue').default})
